import { render, staticRenderFns } from "./IconRotateLeft.vue?vue&type=template&id=23922f3b&scoped=true&"
import script from "./IconRotateLeft.vue?vue&type=script&lang=js&"
export * from "./IconRotateLeft.vue?vue&type=script&lang=js&"
import style0 from "./IconRotateLeft.vue?vue&type=style&index=0&id=23922f3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23922f3b",
  null
  
)

export default component.exports